import React from 'react';
import ServiceShowcase from './ServiceShowcase';

const WorkPage = ({ navigate }) => {
  return (
    <div className="pt-24 pb-32 md:py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen flex flex-col justify-between">
      {/* Main Content Area */}
      <div className="max-w-4xl mx-auto mt-4 md:mt-12 mb-20 flex-grow w-full">
        


        <ServiceShowcase currentPath="/work" navigate={navigate} />

      </div>
    </div>
  );
};

export default WorkPage;
